// Components==============
import { faDownload } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';
import React from 'react';
import './index.module.scss';
// =========================

export function DownloadButton({ file, fileName, text }) {
    let filteredText = text.split('/');
    const { length } = filteredText;
    filteredText = filteredText[length - 1];

    return (
        <motion.a
            href={file}
            download
            styleName="button"
            whileHover={{ backgroundColor: '#1e265c', color: '#fff' }}
        >
            {filteredText}
            <FontAwesomeIcon icon={faDownload} />
        </motion.a>
    );
}
